import { MeterDto } from '../transformers/types'

export const getMeterPairingId = (meter: Nullable<MeterDto>): string => {
  return `${meter.mediaParameters?.address ?? ''}`
}

export const getMeterSerialNumber = (meter: Nullable<MeterDto>): string => {
  return `${meter.mediaParameters?.address ?? ''}`
}
